module.exports = __webpack_public_path__ + "static/media/verintsystems.4cf3e319.jpeg";